import { useCallback } from 'react';

import { Container, LeftSection, RightSection, StickyPageHeaderSkeletonWithButtons } from '@/_containers';
import { SecondaryPageLayoutLoading } from '@/_containers/layout/secondary-page-layout';
import ApiIntegrationLoading from '@/_pages/team-members/api-integration/loading';
import EmergencyLoading from '@/_pages/team-members/emergency/loading';
import MarketingLoading from '@/_pages/team-members/marketing/loading';
import PersonalDetailsLoading from '@/_pages/team-members/personal-details/loading';
import PreferencesLoading from '@/_pages/team-members/preference/loading';
import ProfileLoading from '@/_pages/team-members/profile/loading';
import { ProfileRightSectionLoading } from '@/_pages/team-members/profile/right-section';
import { HeaderLoading } from '@/_pages/team-members/shared/components/header-section';
import { teamMembersSubNav, useCurrentLocation } from '@/_shared';

export function TemplateLoading() {
  const { matched } = useCurrentLocation();

  const { tabKey, renderRightColumn } = matched?.staticData ?? {};

  const render = useCallback(() => {
    switch (tabKey) {
      case 'team-member/api-integration':
        return <ApiIntegrationLoading />;
      case 'team-member/emergency':
        return <EmergencyLoading />;
      case 'team-member/marketing':
        return <MarketingLoading />;
      case 'team-member/personal-details':
        return <PersonalDetailsLoading />;
      case 'team-member/preferences':
        return <PreferencesLoading />;
      case 'team-member/profile':
      default:
        return <ProfileLoading />;
    }
  }, [tabKey]);

  return (
    <SecondaryPageLayoutLoading subNavLinks={teamMembersSubNav}>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={2} allowBack />
      <Container>
        <LeftSection>
          <HeaderLoading />

          {render()}
        </LeftSection>
        {renderRightColumn && (
          <RightSection>
            <ProfileRightSectionLoading />
          </RightSection>
        )}
      </Container>
    </SecondaryPageLayoutLoading>
  );
}
